import { SnapsnapGatewayBase } from './base'
import { Snapsnap } from '@photocreate/snapsnap-api'
import { GetCreditPaymentStatus } from '@/infra/network/Snapsnap/requests/creditOrder'

export default class CreditOrder extends SnapsnapGatewayBase {
  /**
   * クレジット決済ステータスを取得
   *
   * @param fincodeOrderId - Fincode決済のオーダーID（外部決済サービスから提供される）
   * @returns Snapsnap.Credit.GetFincodeTransactionStatusResponse
   */
  async getCreditPaymentStatus(fincodeOrderId: string): Promise<Snapsnap.Credit.GetFincodeTransactionStatusResponse> {
    const response = await this.apiClient.request(new GetCreditPaymentStatus(fincodeOrderId))
    return response
  }
}
